import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import createLink from "../../../../libs/createLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
    faHouse,
    // faImage,
    // faFilmSimple,
    faCircleEllipsis,
    // faUserGroupSimple,
    faSquareList,
    faEarthEurope
} from "@fortawesome/pro-light-svg-icons";



import "./MainNav.scss";
import { apiCropImage } from "../../../../config";
import classNames from "classnames";

const classGenders = {
    1: 'gender-man',
    2: 'gender-woman',
    3: 'gender-couple',
    4: 'gender-couple-lesbian',
    5: 'gender-couple-gay',
    6: 'gender-trav',
    guest: 'guest',
    group: 'group'
};
const MenuAvatar = ({currentUser}) => {
    let avatar = classGenders[currentUser?.profile?.gender || 1] || "gender-man";
    let src = `${process.env.PUBLIC_URL}/images/avatars/${avatar}.jpg`;

    if (currentUser?.profile?.avatar) {
        src = apiCropImage({url: currentUser?.profile?.avatar, width: 52, height: 52});
    }
    return <img src={src} className="main-navbar-item-avatar" alt={`${currentUser?.username} avatar`}/>
}

const MainNav = ({currentUser, openMenu, toggleMenu}) => {
    const location = useLocation(); 
    const isExplorerActive = () => {
        return location.pathname.startsWith('/explorer') ||
               location.pathname.startsWith('/photos') ||
               location.pathname.startsWith('/videos');
    };
    return (
        <div className="main-navbar-wrapper">
            <nav className="main-navbar container">
                <NavLink
                    className="nav-link"
                    end
                    to=""
                >
                    <FontAwesomeIcon icon={faHouse} />
                    <span className="main-navbar-item-title">Accueil</span>
                </NavLink>
                <NavLink
                    className={({ isActive }) =>
                        classNames("nav-link", { "active": isExplorerActive() })
                    }
                    to={createLink('explorer')}
                >
                    <FontAwesomeIcon icon={faEarthEurope} />
                    <span className="main-navbar-item-title">Explorer</span>
                </NavLink>
                {/* <NavLink
                    className="nav-link"
                    to={createLink('photos')}
                >
                    <FontAwesomeIcon icon={faImage} />
                    <span className="main-navbar-item-title">Photos</span>
                </NavLink>
                <NavLink
                    className="nav-link"
                    to={createLink('videos')}
                >
                    <FontAwesomeIcon icon={faFilmSimple} />
                    <span className="main-navbar-item-title">Vidéos</span>
                </NavLink> */}
                {/* <NavLink
                    className="nav-link"
                    to={createLink('members')}
                >
                    <FontAwesomeIcon icon={faUserGroupSimple} />
                    <span className="main-navbar-item-title">Membres</span>
                </NavLink> */}
                <NavLink
                    className="nav-link"
                    to={createLink('forum')}
                >
                    <FontAwesomeIcon icon={faSquareList} />
                    <span className="main-navbar-item-title">Threads</span>
                </NavLink>
                
                <NavLink
                    className={classNames("nav-link", {activeSideView: openMenu})}
                    onClick={toggleMenu}
                    to="menu"
                >
                    {currentUser ? (
                        <MenuAvatar currentUser={currentUser} />
                    ) : (
                        <FontAwesomeIcon icon={faCircleEllipsis} />
                    )}
                    <span className="main-navbar-item-title">Menu</span>
                </NavLink>
            </nav>
        </div>
    )
}

export default MainNav;